export const ReduxAction = {
    AUTOMATION_LIST: 'AUTOMATION_LIST',
    NEW_AUTOMATION: 'NEW_AUTOMATION',
    DRAWER: 'DRAWER',
    SNACK: 'SNACK'
}